import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PasswordChangeEventData } from 'src/app/password-recovery/password-change/password-change.component';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { PasswordRecoveryService, SecretData } from 'src/app/shared/services/password-recovery.service';
import { ToastService } from 'src/app/shared/toast';

@Component({
  selector: 'app-password-change-page',
  templateUrl: './password-change-page.component.html',
  styleUrls: ['./password-change-page.component.scss']
})
export class PasswordChangePageComponent implements OnInit {

  secretData: SecretData | null;
  private readonly HTTP_BUSSINESS_ERROR = 422;
  loading = false;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  private readonly USER_TOKEN_LENGTH = 6;

  constructor(
    private passwordRecoveryService: PasswordRecoveryService,
    private loader: LoaderService,
    private toastService: ToastService,
    private router: Router,
    public breakpointObserver: BreakpointObserver,
    private location: Location,
  ) { }

  ngOnInit(): void {
    this.secretData = this.passwordRecoveryService.getSecretKey();

    if (!this.secretData || !this.secretData.token) {
      this.router.navigate(['/']);
    }
  }

  async handleSaveNewPassword(data: PasswordChangeEventData) {
    try {
      this.loading = true;
      await this.passwordRecoveryService.saveNewPassword({
        secret: this.secretData.secret,
        senha: data.password,
        token: this.normalizeToken(this.secretData.token),
      })
      this.toastService.show({ title: 'Nova senha salva.', text: `Nova senha cadastrada com sucesso.`, type: 'success' });
      this.router.navigate(['/']);
    } catch (responseError) {
      if (responseError && responseError.error) {
        this.toastService.show({ title: 'Não foi possível salvar a nova senha.', text: `Erro ao salvar as informações.`, type: 'error' });
      }
    } finally {
      this.loading = false;
      this.loader.stop();
    }
  }

  handleGoBack() {
    this.router.navigate(['/'], { state: { confirmDeactivate: true } });
  }

  normalizeToken(token: string) {
    if (token.length === this.USER_TOKEN_LENGTH) {
      return token.toLowerCase();
    }

    return token;
  }

}
